import styled from 'styled-components'

const P = styled.p`
  margin: 0;
`
export default P
